import * as React from "react";
import { AutoFixHigh } from "@mui/icons-material";
import { NoResults } from "../../../Components/NoResults";

export const NoAutomations = ({onClick}: any) => (
    <NoResults
        text="You haven't added any automation yet :("
        onClick={onClick}
        icon={<AutoFixHigh />}
    />
);
